import history from "../history";

export const pushLocation = (
  pathname: string,
  operation: "push" | "replace" = "push"
) => {
  return history[operation](pathname);
};
